import React, { Component, Fragment } from 'react';

import ActionGroupChildInputsTable from 'app/developer-v3/pages/actions/ActionGroupInputEditor/ActionGroupChildInputsTable';
import FlowForm from 'app/common/components/FlowForm';
import FormaticConfig from 'app/developer-v3/FormaticConfig';
import { normalizeField } from 'app/developer-v3/utils';

import type { ErrorList } from 'app/developer-v3/types/validator';
import type {
  ActionInputParams,
  FormFieldTemplate,
  FormifiedFieldSchema,
} from 'app/developer-v3/types';

type Props = {
  attemptedSave: boolean;
  deleteInputField: (
    inputFieldSelector: string,
    childFieldIndex: number
  ) => void;
  errors: ErrorList;
  formFields: FormFieldTemplate[];
  formifiedField: FormifiedFieldSchema;
  isFormValid: boolean;
  onFormChange: (form: FormifiedFieldSchema) => void;
  setInputField: () => void;
  params: ActionInputParams;
};

class ActionGroupParentInputEditor extends Component<Props> {
  constructor(props: Props) {
    super(props);
    props.setInputField();
  }

  onBlur = ({ field }: { field: { value: string; key: string } }) => {
    const { formifiedField, onFormChange } = this.props;

    onFormChange({
      ...formifiedField,
      [field.key]: field.value.trim(),
    });
  };

  render() {
    const { props } = this;
    const { formifiedField } = props;
    const formValues = normalizeField(formifiedField);
    const childInputFields = formifiedField?.children;

    return (
      <Fragment>
        <FlowForm
          config={FormaticConfig}
          fields={props.formFields}
          isValid={props.isFormValid}
          meta={{ errors: props.attemptedSave && props.errors }}
          onBlur={this.onBlur}
          onChange={this.props.onFormChange}
          value={formValues}
        />
        {childInputFields && (
          <ActionGroupChildInputsTable {...props} items={childInputFields} />
        )}
      </Fragment>
    );
  }
}

export default ActionGroupParentInputEditor;
